export const LB_HEADER = {
  LB_ADD_LEAVE: 'Add Leave Balance',
  LB_ADD_ASSETS: 'Add Assets',
  LB_ADD_ASSETS_FIELD: 'Add Assets Field',
  LB_EDIT_LEAVE: 'Edit Leave Balance',
  LB_ASSETS: 'Edit Assets',
  LB_ADD_LEAVE_REQUEST: 'Add Leave Request',
  LB_EDIT_LEAVE_REQUEST: 'Edit Leave Request',
  LB_ADD_NEW_LEAVE_TYPE: 'New Leave Type',
  LB_EDIT_LEAVE_TYPE: 'Edit Leave Type',
  LB_APPROVE: 'Leave Approve',
  LB_REJECT: 'Leave Reject',
  LB_SUCCESS_MSG: 'Leave Approve Successfully',
  LB_ASK_LEAVE_APPROVE: 'Are you sure you want to accept this leave request?',
  LB_ASK_LEAVE_REJECT: 'Are you sure you want to reject this leave request?',
  LB_SIGN_OUT: 'Sign Out',
  LB_NOTIFICATION: 'Notifications',
  LB_VIEW_ALL: 'View all notifications',
  LB_HOLIDAY: 'Holiday',
  LB_DEPARTMENT: 'Department',
  LB_DESIGNATION: 'Designation',
  LB_DELETE_LEAVE_TYPE: 'Delete Leave Type',
  LB_DELETE_LEAVE_MESSAGE: 'Are you sure you want to Delete Leave Type ?',
  LB_TBL_COL_TOTAL_LEAVE: 'Total Leaves',
  LB_ADD_EMPLOYEE_HEADER: 'Add Employee',
  LB_EDIT_EMPLOYEE_HEADER: 'Edit Employee',
  LB_LEAVE_REQUEST: 'Leave Request',
  LB_LEAVE_BALANCE: 'Leave Balance',
  LB_EMPLOYEE_ASSETS: 'Assets',
  LB_UPLOAD: 'Upload',
  LB_EXISTING_BALANCE: 'Existing Balance',
  LB_NEW_BALANCE: 'New Balance',
  LB_SUPPORT_TICKET_REQUEST: 'Support Ticket',
  LB_COMPLAIN: 'Complaints',
  LB_ADD_SUPPORT_REQUEST: 'Add Support Request',
  LB_ADD_COMPLAIN_REQUEST: 'Add Complaint Request',
  LB_EDIT_SUPPORT_REQUEST: 'Edit Support Request',
  LB_ASK_SUPPORT_APPROVE: 'Are you sure you want to accept this support request?',
  LB_ASK_SUPPORT_REJECT: 'Are you sure you want to reject this support request?',
  LB_SUPPORT_APPROVE: 'Support Ticket Approve',
  LB_SUPPORT_REJECT: 'Support Ticket Reject',
  LB_ASK_COMPLAIN_APPROVE: 'Are you sure you want to accept this complain request?',
  LB_ASK_COMPLAIN_REJECT: 'Are you sure you want to reject this complain request?',
  LB_COMPLAIN_APPROVE: 'Complaint Ticket Approve',
  LB_COMPLAIN_REJECT: 'Complaint Ticket Reject',
  LB_LAPTOP: 'Laptop',
  LB_PERFORMANCE_EDIT: 'Edit Performance',
  LB_PERFORMANCE_ADD: 'Add Performance',
  LB_EDIT_KPI: 'Edit KPI',
  LB_LOP_OVERTIME_APPROVE: 'LOP or Overtime Approve',
  LB_LOP_OVERTIME_REJECT: 'LOP or Overtime Reject',
  LB_ASK_LOP_OVERTIME_APPROVE: 'Are you sure you want to approve this LOP or Overtime request?',
  LB_ASK_LOP_OVERTIME_REJECT: 'Are you sure you want to reject this LOP or Overtime request?'
};

export const LB_EMPLOYEE = {
  LB_TBL_COL_EMPLOYEE_NAME: 'USER NAME',
  LB_EMPLOYEE_EMAIL: 'EMAIL',
  LB_EMPLOYEE_MOBILE: 'MOBILE',
  LB_EMPLOYEE_ROLE: 'ROLE',
  LB_EMPLOYEE_DESIGNATION: 'DESIGNATION',
  LB_EMPLOYEE_ACTION: 'ACTION'
};

export const LB_EMPLOYEE_PROFILE = {
  LB_TITLE_INFO: 'Personal Information',
  LB_TITLE_INFO_WORK: 'Work Information',
  LB_DOB: 'Date Of Birth',
  LB_GENDER: 'Gender',
  LB_NATIONALITY: 'Nationality',
  LB_MARITAL_STATUS: 'Marital Status',
  LB_EMERGENCY_CONTACT: 'Emergency Contact',
  LB_PERSONAL_EMAIL: 'Personal Email Address',
  LB_ADDRESS: 'Address',
  LB_DEPARTMENT: 'Department',
  LB_REPORTING_MANAGER: 'Project Manager',
  LB_SOURCE_OF_HIRE: 'Source of Hire',
  LB_LOCATION: 'Location',
  LB_DESIGNATION: 'Designation',
  LB_DATE_OF_JOINING: 'Date of Joining',
  LB_EMPLOYMENT_TYPE: 'Employment Type'
};

export const LB_EMPLOYEE_SORT_KEYS = {
  SR_EMPLOYEE_NAME: 'userName',
  SR_EMPLOYEE_EMAIL: 'email',
  SR_EMPLOYEE_MOBILE: 'mobile'
};

export const LB_EMPLOYEE_TABLE_COLS = {
  LB_TBL_COL_EMPLOYEE_NAME: 'NAME',
  LB_TBL_COL_LEAVE_TYPE: 'LEAVE TYPE',
  LB_TBL_COL_FROM: 'FROM',
  LB_TBL_COL_TO: 'TO',
  LB_TBL_COL_REASON: 'REASON',
  LB_TBL_COL_COMMENT: 'COMMENT',
  LB_TBL_COL_SUPPORT_RESPONSE_REASON: 'RESPONSE REASON',
  LB_TBL_COL_STATUS: 'STATUS',
  LB_TBL_COL_APPROVED_BY: 'APPROVED BY',
  LB_TBL_COL_REQUEST_DATE: 'REQUEST DATE',
  LB_TBL_COL_DAY: 'DAYS',
  LB_TBL_COL_LEAVE_CATEGORY: 'Leave Category',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_EMPLOYEE_TABLE_COLS_SORT = {
  SR_EMPLOYEE_NAME: 'userName',
  SR_LEAVE_TYPE: 'leaveType'
};

export const LB_LEAVE_TYPE_TABLE_COLS = {
  LB_TBL_COL_LEAVE_TYPE: 'LEAVE TYPE',
  LB_TBL_COL_LEAVE_CODE: 'LEAVE CODE',
  LB_TBL_COL_CREATED_AT: 'CREATED AT',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_KPI_TABLE_COLS = {
  LB_tBL_COL_NAME: 'Name',
  LB_TBL_COL_DESIGNATION: 'Designation',
  LB_TBL_COL_DEPARTMENT: 'Department',
  LB_TBL_COL_EMPLOYEE: 'Employee',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_ATTENDANCE_APPROVAL_TABLE_COLS = {
  LB_tBL_COL_NAME: 'Employee',
  LB_TBL_COL_DESIGNATION: 'Designation',
  LB_TBL_COL_ARRIVAL_STATUS: 'Arrival Status',
  LB_TBL_COL__STATUS: 'Status',
  LB_TBL_COL_WORK_DURATION: 'Work Duration',
  LB_TBL_COL_TIMES_WORKED: 'Time Worked',
  LB_TBL_COL_REQUEST_DATE: 'Date',
  LB_TBL_COL_START_TIME: 'Start Time',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_LEAVE_TYPE_TABLE_COL_SORT = {
  SR_LEAVE_TYPE: 'name'
};

export const LB_DEPARTMENT_TABLE_COLS = {
  LB_TBL_COL_DEPARTMENT_NAME: 'DEPARTMENT NAME',
  LB_TBL_COL_DEPARTMENT_LEAD_FIELD: 'DEPARTMENT LEAD',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_DEPARTMENT_TABLE_COL_SORT = {
  SR_DEPARTMENT_NAME: 'name'
};

export const LB_HOLIDAY_TABLE_COLS = {
  LB_TBL_COL_HOLIDAY_NAME: 'HOLIDAY NAME',
  LB_TBL_COL_HOLIDAY_DATE: 'HOLIDAY DATE',
  LB_TBL_COL_HOLIDAY_NATIONALITY: 'NATIONALITY',
  LB_TBL_COL_HOLIDAY_DESCRIPTION: 'HOLIDAY DESCRIPTION',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_PAYRUN_TABLE_COLS = {
  LB_TBL_COL_MONTH: 'MONTH',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_HOLIDAY_TABLE_COL_SORT = {
  SR_HOLIDAY_NAME_COL: 'name'
};

export const LB_DESIGNATION_TABLE_COLS = {
  LB_TBL_COL_DESIGNATION_NAME: 'DESIGNATION NAME',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_DESIGNATION_TABLE_COL_SORT = {
  SR_DESIGNATION_NAME: 'name'
};

export const LB_LEAVE_BALANCE_TABLE_COLS = {
  LB_TBL_COL_EMPLOYEE_NAME: 'EMPLOYEE NAME',
  LB_TBL_COL_MATERNITY_LEAVE: 'MATERNITY LEAVES',
  LB_TBL_COL_MENSTRUAL_LEAVES: 'MENSTRUAL LEAVES',
  LB_TBL_COL_PAID_LEAVES: 'PAID LEAVES',
  LB_TBL_COL_PATERNITY_LEAVES: 'PATERNITY LEAVES',
  LB_TBL_COL_SICK_LEAVES: 'SICK LEAVES',
  LB_TBL_COL_WFH: 'WFH',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_ASSETS_TABLE_COLS = {
  LB_TBL_COL_EMPLOYEE_NAME: 'EMPLOYEE NAME',
  LB_TBL_COL_LAPTOP: 'LAPTOP',
  LB_TBL_COL_MONITOR: 'MONITOR',
  LB_TBL_COL_KEYBOARD: 'KEYBOARD',
  LB_TBL_COL_MOUSE: 'MOUSE',
  LB_TBL_COL_CHARGER: 'CHARGER',
  LB_TBL_COL_HDMI: 'HDMI',
  LB_TBL_COL_STAND: 'STAND',
  LB_TBL_COL_EXTENSION_BOARD: 'EXTENSION BOARD',
  LB_TBL_COL_EXTRA_ACCESSORIES: 'EXTRA ACCESSORIES',
  LB_TBL_COL_MOBILE_DEVICE: 'MOBILE DEVICE',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_LEAVE_BALANCE_TABLE_COL_SORT = {
  SR_EMPLOYEE_NAME: 'userName',
  SR_LEAVE_TYPE: 'leaveType'
};

export const LB_EMPLOYEE_LEAVE_REQUEST = {
  LB_AVAILABLE: 'Available',
  LB_BOOKED: 'Booked',
  LB_USED: 'Used'
};

export const LB_ATTENDANCE_TABLE_COLS = {
  LB_TBL_COL_START_TIME: 'START TIME',
  LB_TBL_COL_END_TIME: 'END TIME',
  LB_TBL_COL_TOTAL_HOURS: 'Total Hours',
  LB_TBL_COL_DATE: 'DATE'
};

export const LB_ANNOUNCEMENT_TABLE_COLS = {
  LB_TBL_COL_TITLE: 'TITLE',
  LB_TBL_COL_CREATED_AT: 'CREATED AT',
  LB_TBL_COL_UPDATED_AT: 'UPDATED AT',
  LB_TBL_COL_NATIONALITY: 'NATIONALITY',
  LB_ANNOUNCEMENT_ACTION: 'ACTION'
};

export const LB_NOTE_TABLE_COLS = {
  LB_TBL_COL_TITLE: 'TITLE',
  LB_TBL_COL_NAME: 'NAME',
  LB_TBL_COL_CREATED_AT: 'CREATED AT',
  LB_TBL_COL_UPDATED_AT: 'UPDATED AT',
  LB_NOTE_ACTION: 'ACTION'
};

export const LB_FILES = {
  LB_FILES_HEADER: 'Files',
  LB_ADDED_BY: 'Added by:'
};

export const LB_KPI_MODULE = {
  LB_KPI_HEADER_TITLE: 'KPI',
  LB_KPI_TITLE: 'KPI'
};

export const LB_LOP_OVERTIME_MODULE = {
  LB_LOP_OVERTIME_HEADER_TITLE: 'LOP Overtime',
  LB_LOP_OVERTIME_TITLE: 'LOP Overtime',
  LB_REJECT_LOP_OVERTIME: 'Reject LOP or Overtime',
  LB_APPROVED_LOP_OVERTIME: 'Approved LOP or Overtime',
  LB_EMPLOYEE_LOP_OR_OVERTIME_TITLE: 'LOP or Overtime',
  LB_OVERTIME: 'Overtime',
  LB_TOTAL_OVERTIME_DAYS: 'Total Overtime Days',
  LB_LOP: 'LOP',
  LB_TOTAL_LOP_DAYS: 'Total LOP Days'
};

export const LB_PERFORMANCE_MODULE = {
  LB_PERFORMANCE_HEADER_TITLE: 'Performance',
  LB_PERFORMANCE_TITLE: 'Performance'
};

export const LB_LOP_OVERTIME_TABLE_COLS = {
  LB_TBL_COL_NAME: 'Name',
  LB_TBL_COL_CLAIM_DATE: 'Claim Date',
  LB_TBL_COL_DATE_OF_REQUEST: 'Date of Request',
  LB_TBL_COL_REQUEST_TYPE: 'Type',
  LB_TBL_COL_DAYS: 'Days',
  LB_TBL_COL_REASON: 'Reason',
  LB_TBL_COL_STATUS_REASON: 'Status Reason',
  LB_TBL_COL_ACTION: 'ACTION'
};

export const LB_ATTENDANCE_APPROVAL_MODULE = {
  LB_ATTENDANCE_APPROVAL_HEADER_TITLE: 'Attendance Approval',
  LB_ATTENDANCE_APPROVAL_TITLE: 'Attendance Approval',
  LB_STATUS_UPDATE: 'Status Update',
  LB_ASK_STATUS_UPDATE: 'Are you sure you want to update the status request?'
};
